import { uploadImage } from '../api/uploads';

export const compressImage = (file, maxWidth = 1200, maxHeight = 1200, quality = 0.8) =>
  new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.onload = () => {
      let { width, height } = img;
      if (width > height && width > maxWidth) {
        height = (height * maxWidth) / width;
        width = maxWidth;
      } else if (height > maxHeight) {
        width = (width * maxHeight) / height;
        height = maxHeight;
      }
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);
      canvas.toBlob(resolve, 'image/jpeg', quality);
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });

export const readFileAsDataURL = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => resolve(event.target.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

/**
 * Compress (optionally), read and upload an image file.
 * Returns the hosted image URL.
 */
export const uploadImageFile = async (file, publicId, { compress = true } = {}) => {
  const prepared = compress ? await compressImage(file) : file;
  if (!prepared) throw new Error('Image processing failed');
  const dataUrl = await readFileAsDataURL(prepared);
  return uploadImage(dataUrl, publicId);
};
